import React from "react";

function ViewToggle({ viewMode, onViewChange, storageKey = "itemsViewMode" }) {
  const handleToggle = (mode) => {
    if (onViewChange) {
      onViewChange(mode);
    }
    if (storageKey) {
      localStorage.setItem(storageKey, mode);
    }
  };

  return (
    <div className="hidden lg:flex bg-gray-100 p-0.5 rounded-lg border border-gray-200/50 shadow-sm select-none">
      <button
        onClick={() => handleToggle("table")}
        className={`px-3 py-1.5 rounded-md flex items-center gap-1.5 text-xs font-semibold transition-all ${
          viewMode === "table"
            ? "bg-white text-gray-800 shadow-sm"
            : "text-gray-500 hover:text-gray-800"
        }`}
        title="Table View"
      >
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          />
        </svg>
      </button>
      <button
        onClick={() => handleToggle("card")}
        className={`px-3 py-1.5 rounded-md flex items-center gap-1.5 text-xs font-semibold transition-all ${
          viewMode === "card"
            ? "bg-white text-gray-800 shadow-sm"
            : "text-gray-500 hover:text-gray-800"
        }`}
        title="Card View"
      >
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
          />
        </svg>
      </button>
    </div>
  );
}

export default ViewToggle;
